import { SxProps, Theme } from '@mui/material';

export const cardThemeStyles = {
  // Stile del contenitore Paper delle Card
  cardPaper: {
    flex: 1,
    p: 3,
    minWidth: { xs: '100%', md: '350px' },
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#ffffff',
    borderRadius: '10px',
    boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.06), 0px 1px 3px rgba(0, 0, 0, 0.02)'
  } as SxProps<Theme>,

  // Intestazione con Icona tonda celeste
  headerContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    mb: 3,
    flexWrap: 'wrap'
  } as SxProps<Theme>,

  iconCircle: {
    p: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#E9F2F7', // Celeste chiaro
    borderRadius: '50%',
    '& .MuiSvgIcon-root': {
      color: '#2479B1' // Blu icone
    }
  } as SxProps<Theme>,

  headerTitle: {
    color: '#2479B1',
    fontSize: '1.25rem'
  } as SxProps<Theme>,

  // Stile specifico dei Chip di stato
  statusChip: {
    backgroundColor: '#E9F2F7',
    color: '#1d70b8',
    fontSize: '0.75rem',
    padding: '4px 6px',
    height: '24px',
    border: '1px solid rgba(29, 112, 184, 0.15)',
    borderRadius: '10px'
  } as SxProps<Theme>,

  badgeChip: (isExpired?: boolean) => {
    const backgroundColor = isExpired ? '#FEF7E0' : '#E6F4EA';
    const color = isExpired ? '#B06000' : '#137333';
    const borderColor = isExpired ? 'rgba(176, 96, 0, 0.15)' : 'rgba(19, 115, 51, 0.15)';

    return {
      fontSize: '0.75rem',
      borderRadius: '10px',
      height: '24px',
      backgroundColor: backgroundColor,
      color: color,
      border: `1px solid ${borderColor}`,
      textTransform: 'uppercase',
      letterSpacing: '0.02em',
      '& .MuiChip-label': {
        paddingLeft: '8px',
        paddingRight: '8px'
      }
    } as SxProps<Theme>;
  },

  // Layout delle righe interne
  flexRowWrap: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 2
  } as SxProps<Theme>,

  flexRowSpaceBetween: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 2
  } as SxProps<Theme>
};
